import { render, staticRenderFns } from "./CertificatePage.vue?vue&type=template&id=457280f8&scoped=true"
import script from "./CertificatePage.vue?vue&type=script&lang=js"
export * from "./CertificatePage.vue?vue&type=script&lang=js"
import style0 from "./CertificatePage.vue?vue&type=style&index=0&id=457280f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457280f8",
  null
  
)

export default component.exports